export default __webpack_public_path__ + "static/media/email-white.294cb539.svg";